<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'switch'">
    <label *ngIf="!!inline">
      {{ label | translate }}
      <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
    </label>

    <div class="fx-row fx-align-center fx-gap">
      <div class="fx-inline">
        <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
      </div>

      <label *ngIf="!inline">
        {{ label | translate }}
        <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
      </label>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'radio'">
    <label>
      {{ label | translate }}
      <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
    </label>
    <div class="fx-column radio-options">
      <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'text'">
    <label>
      {{ label | translate }}
      <ng-template [ngTemplateOutlet]="rowLabelOutlet"></ng-template>
    </label>
    <div class="fx-row">
      <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'button'">
    <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'card'">
    <ng-container [ngTemplateOutlet]="contentOutlet"></ng-container>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <av-card type="warning">
      <av-card-body size="xs"
        >av-control-row: Unsupported or missing type</av-card-body
      >
    </av-card>
  </ng-container>
</ng-container>

<div class="type-{{ type }}-help" *ngIf="!!help">
  <small class="text-muted">
    {{ help | translate }}
  </small>
</div>

<div
  *ngIf="isHelpProjected"
  class="type-{{ type }}-help-projected help-projected"
>
  <small class="text-muted">
    <ng-content select="[row-help]"></ng-content>
  </small>
</div>

<ng-template #rowLabelOutlet>
  <ng-content select="[row-label]"></ng-content>
</ng-template>

<ng-template #contentOutlet>
  <ng-content></ng-content>
</ng-template>
